export function updateSupportSubject(value) {
	return {
		type: "updateSupportSubject",
		value,
	};
}

export function updateSupportText(value) {
	return {
		type: "updateSupportText",
		value,
	};
}

export function submitSupportTicketInit() {
	return {
		type: "submitSupportTicketInit",
	};
}

export function supportTicketSubmitResponse(data) {
	if (data === "success") {
		return {
			type: "supportTicketSubmitSuccessful",
		};
	} else {
		return {
			type: "supportTicketSubmitError",
			data,
		};
	}
}

export function clearSupportModalError() {
	return {
		type: "clearSupportModalError",
	};
}
